import React from 'react';
import PropTypes from 'prop-types';
import StateStatsChart from "./StateStatsChart";
import {compose} from 'react-apollo';
import queries from "../../graphql/queries";
import {renderGraphQLStatusOrNull} from "../../utils/utils";
import _ from 'lodash';

export default compose(
    queries.stateEntrancesAndExitsCountByHoursQueryHocWithName("stateStatsByHours"),
    queries.itemCountByStatesQueryHocWithName("itemsCountByStates")
)(class extends React.Component {

    static propTypes = {
        project: PropTypes.object.isRequired,
        stateStatsByHours: PropTypes.object.isRequired,
        itemsCountByStates: PropTypes.object.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    renderStateGraphs() {
        let stateStatsByStateId = _.keyBy(this.props.stateStatsByHours.stateEntrancesAndExitsCountByHours, 'stateId');
        let itemCountByStateIds = _.keyBy(this.props.itemsCountByStates.itemCountByStates, 'stateId');

        return _.filter(this.props.project.states, {type: 'normal'}).map(state => {
            let entrances = [];
            let exits = [];
            let itemCount = 0;
            if (state.id in stateStatsByStateId) {
                entrances = stateStatsByStateId[state.id].entrances;
                exits = stateStatsByStateId[state.id].exits;
            }
            if (state.id in itemCountByStateIds) {
                itemCount = itemCountByStateIds[state.id].count;
            }
            return <StateStatsChart
                key={state.id}
                state={state}
                entrances={entrances}
                exits={exits}
                itemCount={itemCount}
            />
        });
    }

    render() {
        return renderGraphQLStatusOrNull([this.props.stateStatsByHours, this.props.itemsCountByStates]) || (
            <div className="statesDaysHistogramContainer">
                {this.renderStateGraphs()}
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/analytics/StatesAnalytics.js